<template>

    <section class="px-24 mt-16 sm-max:px-8 md-max:mt-10">

        <div class="grid grid-cols-2 lg:gap-x-6 sm:gap-y-8 gap-y-6">

            <div v-for="(review, index) in reviews" :key="review.reviewerName" class="col-span-1 md-max:col-span-2">
                <div class="flex flex-col h-full pt-8 pb-6 space-y-2 sm:space-y-4 px-7 bg-grayReview md-only:p-8 md-max:p-4 sm:min-h-full min-h-36">
                    <div class="h-6">
                        <nuxt-img class="m-auto md-only:my-2 sm-max:w-24" loading="lazy" alt="review-rating" width="148" height="23"
                            :src="review.reviewImage"></nuxt-img>
                    </div>
                    <div class="grid h-full text-xl font-bold text-center jutify-start lg:text-3xl md:text-2xl"
                        v-html="review.reviewTitle"></div>

                    <div class="flex items-center justify-end pt-2 md:pt-6 gap-x-1">
                        <div class="pb-1 text-lg font-bold leading-4 sm:text-22" v-html="review.reviewerName"></div>
                        <div class="pb-1 text-lg leading-4 sm:text-22" v-html="review.reviewerLocation"></div>
                    </div>


                </div>


            </div>

        </div>


    </section>

</template>


<script setup>

const props = defineProps({
    reviews: {
        type: Array,
        default: () => [
            {
                reviewImage: "/assets/images/freebag-rate-5.jpg",
                reviewTitle: "“There Just Is No Better”",
                reviewerName: "Sonia P,",
                reviewerLocation: "USA"
            },
            {
                reviewImage: "/assets/images/freebag-rate-5.jpg",
                reviewTitle: "“Best Coffee <br class='md-max:hidden'/> " +
                    "I’ve Ever Tasted”",
                reviewerName: "Ziggy L,",
                reviewerLocation: "USA"
            },
            {
                reviewImage: "/assets/images/freebag-rate-5.jpg",
                reviewTitle: "“This Coffee Is Delicious”",
                reviewerName: "Chrissy B,",
                reviewerLocation: "USA"
            },
            {
                reviewImage: "/assets/images/freebag-rate-5.jpg",
                reviewTitle: "“It Is Smooth, No Bitterness, With Full Bodied Flavor”",
                reviewerName: "Nichele G,",
                reviewerLocation: "USA"
            },
        ]
    }
})

defineBuilderComponent({
    friendlyName: "ReviewShort",
    canHaveChildren: true,
    inputs: [
        {
            name: "reviews",
            type: "list",
            defaultValue: [
                {
                    reviewImage: "/assets/images/freebag-rate-5.jpg",
                    reviewTitle: "“There Just Is No Better”",
                    reviewerName: "Sonia P,",
                    reviewerLocation: "USA"
                },
                {
                    reviewImage: "/assets/images/freebag-rate-5.jpg",
                    reviewTitle: "“Best Coffee  I’ve Ever Tasted",
                    reviewerName: "Ziggy L,",
                    reviewerLocation: "USA"
                },
                {
                    reviewImage: "/assets/images/freebag-rate-5.jpg",
                    reviewTitle: "“This Coffee Is Delicious”",
                    reviewerName: "Chrissy B,",
                    reviewerLocation: "USA"
                },
                {
                    reviewImage: "/assets/images/freebag-rate-5.jpg",
                    reviewTitle: "“It Is Smooth, No Bitterness, With Full Bodied Flavor”",
                    reviewerName: "Nichele G,",
                    reviewerLocation: "USA"
                }
            ],
            subFields: [
                {
                    name: "reviewImage",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "svg"
                    ],
                    defaultValue: "/assets/images/freebag-rate-5.jpg",
                    required: true
                },
                {
                    name: "reviewTitle",
                    type: "richText",
                    defaultValue: "review title"
                },
                {
                    name: "reviewerName",
                    type: "richText",
                    defaultValue: "Reviewer Name"
                },
                {
                    name: "reviewerLocation",
                    type: "richText",
                    defaultValue: "Reviewer Location"
                }
            ]
        }
    ]
});
</script>